var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _path24, _rect2, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigninEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 249,
    viewBox: "0 0 268 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.407 140.075C25.1003 147.796 30.7842 154.782 37.0429 161.305C40.3011 164.701 44.3389 169.268 48.8555 171.539C62.6805 179.589 94.5451 188.644 94.5451 188.644C94.5451 188.644 129.105 189.85 148.015 188.858C167.685 187.826 185.051 192.947 201.407 181.713C212.319 174.219 224.129 164.4 232.42 154.246C237.066 148.557 252.015 130.725 251.753 123.398C251.2 107.923 238.375 99.4417 227.238 88.7893C224.835 86.4905 217.483 82.8029 216.965 79.175C216.444 75.5169 212.347 66.5545 209.397 64.2252C201.668 58.1227 191.915 48.253 182.795 44.0836C169.494 38.0031 133.771 40.5004 123.51 42.9435C107.549 46.7438 92.6338 57.4321 81.5827 60.1417C76.0808 61.4907 71.5563 63.749 66.6027 66.4794C58.4977 70.9468 50.0989 75.1256 42.5885 80.5603C37.1282 84.5115 26.0204 90.8158 22.0057 95.7821C12.0428 108.106 12.8904 127.709 20.407 140.075Z",
    fill: "#FFD5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 131.603C180.395 124.786 179.203 116.039 177.98 111.094C175.489 101.026 175.333 96.1074 166.981 87.5036C151.013 71.0541 122.36 73.8024 104.428 85.5791C99.3313 88.9264 96.3458 92.8712 93.4907 99C86.9965 112.94 89.5146 127.5 98.6079 139.902C106.749 151.006 123.886 156.6 130.295 155.262C142.035 152.81 144.25 154.655 156.491 147.5C163.75 143.256 171.758 138.79 176.19 131.603Z",
    fill: "#3DA7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.145 126.377C166.039 121.685 165.219 115.664 164.377 112.26C162.662 105.33 160.555 100.945 154.806 95.0224C143.815 83.7 126.093 86.5917 113.75 94.6978C110.242 97.0017 106.027 101.371 104.611 106.296C101.96 115.521 102.482 124.923 108.432 132.712C114.186 140.244 127.143 143.583 131.555 142.661C139.636 140.974 144.136 140.555 151.289 136.751C156.399 134.033 160.094 131.324 163.145 126.377Z",
    fill: "#4ABBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.193,
    cy: 115.33,
    r: 3.57831,
    fill: "#2C2727"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.525,
    cy: 115.33,
    r: 3.57831,
    fill: "#2C2727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.781 121.771C129.781 123.647 131.596 125.349 134.075 125.349C136.554 125.349 138.369 123.647 138.369 121.771H139.8C139.8 124.637 137.129 126.78 134.075 126.78C131.02 126.78 128.349 124.637 128.349 121.771H129.781Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5437 176.059C31.9368 177.303 33.5276 178.506 35.8304 179.682C37.0292 180.294 38.3457 181.098 41.1555 181.635C49.239 183.418 72.3469 186.314 72.3469 186.314C72.3469 186.314 96.285 189.76 112.998 190.665C130.384 191.606 148.073 191.801 167.419 191.257C180.326 190.893 195.1 190.282 207.008 189.436C213.681 188.961 234.928 187.496 238.156 186.545C244.974 184.536 237.953 182.752 233.405 180.782C232.424 180.357 227.846 179.484 229.111 178.992C230.387 178.496 231.091 177.126 229.654 176.667C225.89 175.465 222.163 173.671 216.293 172.641C207.731 171.138 175.864 169.508 165.898 169.261C150.394 168.877 132.543 169.43 121.772 169.174C116.41 169.046 111.458 169.088 105.916 169.167C96.8471 169.296 87.6621 169.373 78.6485 169.658C72.0953 169.866 59.5813 170.066 53.7917 170.482C39.4242 171.515 30.914 174.068 31.5437 176.059Z",
    fill: "#FE8591"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2326 154.399C44.6757 139.38 39.4615 107.98 56.517 89.1383",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5285 135.533C46.5285 135.533 52.6812 137.252 58.4576 134.906C64.234 132.561 68.2584 129.038 67.4465 127.039C66.6346 125.039 61.2937 125.32 55.5174 127.665C49.741 130.011 46.5285 135.533 46.5285 135.533Z",
    fill: "#70D693"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8238 135.127C43.8238 135.127 37.5254 136.195 32.0249 133.261C26.5244 130.326 22.8888 126.404 23.9047 124.5C24.9205 122.596 30.2031 123.431 35.7036 126.366C41.2041 129.3 43.8238 135.127 43.8238 135.127Z",
    fill: "#70D693"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 123.786C43.4464 123.786 37.1606 122.647 32.9879 118.014C28.8152 113.382 26.7324 108.456 28.3358 107.012C29.9392 105.568 34.6217 108.152 38.7944 112.784C42.9671 117.416 43.4464 123.786 43.4464 123.786Z",
    fill: "#70D693"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2223 111.016C44.2223 111.016 38.5972 107.987 36.0619 102.292C33.5266 96.5962 33.0695 91.2675 35.0411 90.3899C37.0127 89.5123 40.6662 93.4181 43.2015 99.1137C45.7368 104.809 44.2223 111.016 44.2223 111.016Z",
    fill: "#70D693"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.068 98.531C48.068 98.531 43.9808 93.6213 43.7559 87.3909C43.531 81.1606 45.097 76.0467 47.2536 75.9689C49.4103 75.8911 51.3409 80.8786 51.5658 87.109C51.7907 93.3393 48.068 98.531 48.068 98.531Z",
    fill: "#70D693"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8321 87.7795C55.8321 87.7795 53.8421 81.7089 55.9293 75.8343C58.0165 69.9596 61.357 65.783 63.3905 66.5055C65.424 67.228 65.3805 72.576 63.2933 78.4507C61.2062 84.3253 55.8321 87.7795 55.8321 87.7795Z",
    fill: "#70D693"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0904 96.4674C54.0904 96.4674 57.0086 90.7845 62.6539 88.139C68.2992 85.4934 73.6179 84.9329 74.5337 86.887C75.4495 88.8412 71.6154 92.5699 65.9702 95.2155C60.3249 97.861 54.0904 96.4674 54.0904 96.4674Z",
    fill: "#70D693"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1498 111.071C48.1498 111.071 50.3612 105.078 55.6461 101.771C60.931 98.4635 66.1434 97.2655 67.2882 99.0949C68.433 100.924 65.0767 105.088 59.7918 108.396C54.5069 111.703 48.1498 111.071 48.1498 111.071Z",
    fill: "#70D693"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4121 122.438C46.4121 122.438 49.3983 116.79 55.0749 114.213C60.7515 111.635 66.0766 111.138 66.9689 113.103C67.8611 115.068 63.9827 118.751 58.3061 121.329C52.6295 123.906 46.4121 122.438 46.4121 122.438Z",
    fill: "#70D693"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 144H58.9999L57.206 173.062C57.1734 173.589 56.7362 174 56.2079 174H36.7919C36.2635 174 35.8264 173.589 35.7938 173.062L33.9999 144Z",
    fill: "#8D4891"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.167 149C199.614 149 199.167 149.448 199.167 150V177.167C199.167 177.321 199.201 177.466 199.263 177.596C199.199 177.647 199.167 177.698 199.167 177.75C199.167 178.44 204.95 179 212.083 179C217.707 179 222.492 178.652 224.265 178.167H225V150C225 149.448 224.552 149 224 149H200.167Z",
    fill: "#FF6D3E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.083,
    cy: 149.417,
    rx: 12.0833,
    ry: 1.25,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.167 176.917V150.25H200V176.917H199.167Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200 154.833C194.782 154.833 192.5 157.679 192.5 161.744C192.5 165.809 192.5 171.5 200 171.5",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.321 129.107C176.449 129.037 176.593 129 176.739 129H220.089C220.991 129 221.298 130.203 220.506 130.636L164.182 161.386C164.054 161.456 163.91 161.492 163.764 161.492H120.414C119.512 161.492 119.204 160.289 119.996 159.856L176.321 129.107Z",
    fill: "#F2F2F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.764 136.22H198.231",
    stroke: "#2C2727",
    strokeWidth: 0.871219,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.518 143.44H181.985",
    stroke: "#2C2727",
    strokeWidth: 0.871219,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.273 152.466H165.739",
    stroke: "#2C2727",
    strokeWidth: 0.871219,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.1219,
    y: 93.9598,
    width: 57.4612,
    height: 6.38458,
    transform: "rotate(54.8408 54.1219 93.9598)",
    fill: "#FEC42E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2105 140.937L81.9908 144.613L87.6645 147.125L87.2105 140.937Z",
    fill: "#2C2727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.51277,
    height: 6.38458,
    transform: "matrix(-0.575851 -0.817555 -0.817555 0.575851 54.1219 93.9598)",
    fill: "#FE636B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103 58L104.891 63.4743L110 65.5L104.891 67.5257L103 73L101.109 67.5257L95.9999 65.5L101.109 63.4743L103 58Z",
    fill: "#4ABBFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 48L165.606 56.029L174 59L165.606 61.971L162.5 70L159.394 61.971L151 59L159.394 56.029L162.5 48Z",
    fill: "#FE8591"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M196 87L198.431 93.5692L205 96L198.431 98.4308L196 105L193.569 98.4308L187 96L193.569 93.5692L196 87Z",
    fill: "#4ABBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninEmail);
export default __webpack_public_path__ + "static/media/signin-email.572525042938bf0d04085c6b8f468317.svg";
export { ForwardRef as ReactComponent };